import { axiosInstance } from '../request';
export const getMemoryNotes = async () => {
    const response = await axiosInstance.get('/api/v1/memories/notes');
    return response.data;
};
export const createMemoryNote = async (data) => {
    const response = await axiosInstance.post(`/api/v1/memories/notes`, data);
    return response.data;
};
export const updateMemoryNote = async (data) => {
    const response = await axiosInstance.patch(`/api/v1/memories/notes/${data.id}`, data);
    return response.data;
};
export const deleteMemoryNote = async (id) => {
    await axiosInstance.delete(`/api/v1/memories/notes/${id}`);
};
//# sourceMappingURL=memoryNotes.api.js.map